import { Injectable } from '@angular/core';
import { OrderShoppingPaymentView } from '../views';

@Injectable()
export class OrderShoppingPaymentFormNotifierService {
    updatePayment: (payment: OrderShoppingPaymentView) => void = (payment: OrderShoppingPaymentView) => { };
    
}